/** @format */
import extensionApplicationSummaryTpl from './extensionApplicationSummary.tpl.html';
'use strict';
(function () {
  angular.module('sis-components.applications.extensionApplicationSummary', []).component('extensionApplicationSummary', {
    template: extensionApplicationSummaryTpl,
    bindings: {
      application: '<'
    }
  });
})();